import { useQuery } from '@tanstack/react-query';
import { userOptions } from '../../constants/user';
export function useUser() {
    const { data, isLoading, isSuccess } = useQuery(userOptions.me());
    return {
        user: data ?? undefined,
        loadingUser: isLoading,
        isSuccess,
    };
}
